/* Copyright Levelise Ltd 2026 */
import { createContext, useState, useMemo } from 'react';
import { TIME_FRAMES } from '../utils/constants';

const defaultValues = {
	selectedTimezone: '',
	selectedTimeFrame: TIME_FRAMES.twenty_four_hours,
	startDate: undefined,
	endDate: undefined,
	resetZoom: false,
	timeFrameChanging: false,
	facilityTimezone: '',
	setSelectedTimezone: () => {},
	setSelectedTimeFrame: () => {},
	setStartDate: () => {},
	setEndDate: () => {},
	setResetZoom: () => {},
	setTimeFrameChanging: () => {},
	setFacilityTimezone: () => {},
};

const NavBarContext = createContext(defaultValues);

export const NavBarProvider = ({ children }) => {
	const [selectedTimezone, setSelectedTimezone] = useState('');
	const [selectedTimeFrame, setSelectedTimeFrame] = useState(TIME_FRAMES.twenty_four_hours);
	const [startDate, setStartDate] = useState(undefined);
	const [endDate, setEndDate] = useState(undefined);
	const [resetZoom, setResetZoomValue] = useState(false);
	const [timeFrameChanging, setTimeFrameChanging] = useState(false);
	const [facilityTimezone, setFacilityTimezone] = useState('');

	const value = useMemo(
		() => ({
			selectedTimezone,
			selectedTimeFrame,
			startDate,
			endDate,
			resetZoom,
			timeFrameChanging,
			facilityTimezone,
			setSelectedTimezone,
			setSelectedTimeFrame,
			setStartDate,
			setEndDate,
			setResetZoom: () => setResetZoomValue((v) => !v),
			setTimeFrameChanging,
			setFacilityTimezone,
		}),
		[selectedTimezone, selectedTimeFrame, startDate, endDate, resetZoom, timeFrameChanging, facilityTimezone],
	);

	return <NavBarContext.Provider value={value}>{children}</NavBarContext.Provider>;
};

export default NavBarContext;
